export class Residence {
    code: string;
    displayName: string;
}
